"use client";

import React, { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function DialogueMeaningSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const {
    ref: quoteRef,
    isVisible: isQuoteVisible
  } = useRevealOnScroll();
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const section = sectionRef.current;
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const start = sectionTop - windowHeight / 2;
      const end = sectionTop + sectionHeight - windowHeight / 2;
      let progress = (scrollY - start) / (end - start);
      progress = Math.max(0, Math.min(1, progress));
      setScrollProgress(progress);
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="tarinamme" ref={sectionRef} className="relative bg-sidebar py-12 lg:py-16 overflow-hidden">
      {}
      <div className="absolute left-6 lg:left-12 top-0 bottom-0 w-px bg-border hidden md:block">
        <div className="w-full bg-primary transition-all duration-100 ease-out" style={{
        height: `${scrollProgress * 100}%`
      }} />
      </div>

      <div className="container mx-auto px-6 md:px-12 lg:px-24 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-start">
          
          {}
          <div ref={quoteRef} className={cn("lg:col-span-5 transition-all duration-1000 ease-out transform", isQuoteVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <div className="sticky top-32">
              <h2 className="font-serif text-4xl leading-tight tracking-tight !text-[rgba(24,46,78,1)] md:text-5xl lg:text-6xl">”Dialogi alkaa kuuntelemisesta.”</h2>
              <div className="mt-6 h-1 w-12 bg-primary/20" />
            </div>
          </div>

          {}
          <div ref={textRef} className={cn("lg:col-span-7 flex flex-col gap-8 transition-all duration-1000 delay-200 ease-out transform", isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <p className="text-2xl font-light leading-relaxed !text-[rgba(24,46,78,1)] md:text-3xl">Meille mediatuotanto on enemmän kuin tekninen toteutus. Se alkaa ymmärryksestä: mikä on tarina, joka kannattaa kertoa, ja kenelle.</p>
            
            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed font-sans">
              <p>Mediatuotanto nähdään usein teknisenä toteutuksena. Meille se on ymmärtämistä. Laadukas ja vaikuttava lopputulos syntyy syvästä ymmärryksestä ja aidosta kohtaamisesta.</p>
              <p>Kun maltamme kuunnella ensin, löydämme tarinan ytimen, joka puhuttelee ja vaikuttaa pitkään. Siksi tuotamme videoita, musiikkia ja mediasisältöjä, jotka eivät ainoastaan näytä hyvältä vaan myös jättävät muistijäljen. Harkittu tarinankerronta ei synny kiireessä, vaan se vaatii struktuuria, rauhaa ja kykyä nähdä pintaa syvemmälle.</p>
              <p>Olipa kyseessä kunta, yritys tai yhteisö, tavoitteemme on sama: tehdä näkyväksi ihmiset, paikat ja tarinat, jotka ansaitsevat tulla nähdyiksi.</p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}